import { Autocomplete, TextField } from "@mui/material";
import InputBox from "./InputBox";
import { PField } from "./NestedField";
import { fieldHasError, requiredValidator } from "./validator";

export default function AutocompleteInput({ name, label, required, helperText, initialValue, sx, children, ...props }) {
    return (
        <InputBox sx={sx}>
            <PField name={name} initialValue={initialValue} validate={required ? requiredValidator : null}>
                {(fieldProps) => {
                    const hasError = fieldHasError(fieldProps.meta);

                    return (
                        <Autocomplete
                            sx={{ flex: 1 }}
                            renderInput={(params) => (
                                <TextField
                                    label={label}
                                    required={required}
                                    error={hasError}
                                    helperText={hasError ? fieldProps.meta.error : helperText}
                                    variant="standard"
                                    {...params}
                                    value={fieldProps.input.value || ''}
                                />
                            )}
                            {...fieldProps.input}
                            {...props}
                            onChange={(event, value) => {
                                // Necessário para passar os valores do MUI para o Final Form imediatamente.
                                fieldProps.input.onChange(value);
                            }}
                        />
                    );
                }}
            </PField>
        </InputBox>
    );
}
